// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import {WebSocketClient} from '@mattermost/client';

const WebClient = new WebSocketClient();
export default WebClient;
